import { createSlice } from '@reduxjs/toolkit';
import { PAGINATION } from '@/constants/pagination';

// todo: need to remove once api is done
const reducerName = 'contactsList';
const initialState = {
  searchTerm: null,
  filters: {
    // old filters - remove once new filter fully implemented
    stage: [],
    outreach_ids: [],
    outreach_sourced_by: [],
    outreach_status: [],
    company_employee_range: [],
    company_id: [],
    company_industry: [],
    position: [],
    skills: [],
    location: [],
    tags: [],
    user_ids: [],
    top_talent: false,
    updatePage: true,
    candidate_source: [],
    job_ids: [],
    project_ids: [],
    rejection_reason_ids: [],
    eeo_status: [],
    resume: [],

    // new filters
    feConfig: [],
    beConfig: {},

    isFilterApplied: false,
    refetchTimestamp: null, // Used to trigger refetch without resetting page
  },
  page: {
    number: 0,
    limit: PAGINATION.CONTACTS,
    scroll_token: null,
  },
  sort: {
    label: 'Last activity (Newest)',
    value: 'desc',
    element: 'tst',
    order: 'desc',
  },
};

const { reducer, actions: contactsListActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    resetJobState: (state, { payload: { key } }) => {
      state[key] = { ...initialState[key] };
    },

    applySort: (state, { payload }) => {
      state.sort = payload;
      // Reset page and scroll_token when sort changes, but preserve the current limit
      state.page = { ...initialState.page, limit: state.page.limit };
    },

    applyFilter: (state, { payload }) => {
      const { key, value, feConfig, beConfig } = payload;
      if (feConfig) {
        state.filters.feConfig = feConfig;
      }
      if (beConfig) {
        state.filters.beConfig = beConfig;
      }

      if (key && value) {
        state.filters[key] = value;
      }

      // Reset page and scroll_token when filter changes, but preserve the current limit
      state.page = { ...initialState.page, limit: state.page.limit };
      state.filters.isFilterApplied = true;
    },

    applyPage: (state, { payload }) => {
      const { page, scroll_token } = payload;
      state.page.number = page;
      // Update scroll_token if provided in payload, otherwise keep the existing one
      if (scroll_token !== undefined) {
        state.page.scroll_token = scroll_token;
      }
    },

    updateScrollToken: (state, { payload }) => {
      const { scroll_token } = payload;
      state.page.scroll_token = scroll_token;
    },

    applyLimit: (state, { payload }) => {
      const { limit } = payload;
      state.page.limit = limit;
      // Reset page to 0 and clear scroll_token when limit changes
      state.page.number = 0;
      state.page.scroll_token = null;
    },

    applyTopTalent: (state) => {
      state.filters.top_talent = !state.filters.top_talent;
      // Reset page and scroll_token when top talent filter changes, but preserve the current limit
      state.page = { ...initialState.page, limit: state.page.limit };
    },

    clearFilter: (state, { payload }) => {
      const { key } = payload;
      state.filters[key] = initialState.filters[key];
      // Reset page and scroll_token when filter is cleared, but preserve the current limit
      state.page = { ...initialState.page, limit: state.page.limit };
      state.filters.isFilterApplied = Object.values(state.filters).some(
        (filter) => filter !== initialState.filters[key]
      );
    },

    clearAllFilter: (state) => {
      state.filters = { ...initialState.filters };
      // Reset page and scroll_token when clearing all filters, but preserve the current limit
      state.page = { ...initialState.page, limit: state.page.limit };
      // Keep isFilterApplied true - clearing filters IS a user action
      // This prevents default filters from being re-applied
      state.filters.isFilterApplied = true;
    },

    clearData: (state) => {
      state.sort = { ...initialState.sort };
      state.currentView = initialState.currentView;
      state.searchTerm = '';
    },

    applySearch: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
      // Reset page and scroll_token when search changes, but preserve the current limit
      state.page = { ...initialState.page, limit: state.page.limit };
      state.filters.isFilterApplied = payload?.searchTerm?.length > 0;
    },

    // Trigger a refetch WITHOUT resetting page - for bulk operations
    // This just updates a timestamp to invalidate cached data
    triggerRefetch: (state) => {
      state.filters.refetchTimestamp = Date.now();
    },
  },
});

export { contactsListActions };
export default reducer;
